import { Radar, RadarChart as RechartsRadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';
import { formatDimensionName } from '../../utils/scoreHelpers';

export default function RadarChart({ scores }) {
  const data = Object.entries(scores).map(([key, val]) => ({
    dimension: formatDimensionName(key),
    score: typeof val === 'object' ? val.score : val,
    fullMark: 100
  }));

  return (
    <div className="card">
      <h2 className="text-lg font-semibold mb-2">Skill Radar</h2>
      <div className="w-full" style={{ height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <RechartsRadarChart data={data} cx="50%" cy="50%" outerRadius="60%">
            <PolarGrid stroke="#e5e7eb" />
            <PolarAngleAxis
              dataKey="dimension"
              tick={{ fill: '#37352F', fontSize: 13, fontWeight: 600 }}
            />
            <PolarRadiusAxis
              angle={90}
              domain={[0, 100]}
              tick={{ fill: '#9ca3af', fontSize: 10 }}
              tickCount={5}
            />
            <Radar
              name="Score"
              dataKey="score"
              stroke="#2383E2"
              fill="#2383E2"
              fillOpacity={0.2}
              strokeWidth={2}
            />
          </RechartsRadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
